{
  "de": {
    "survey_type": {
      "actions": {
        "changeResponsible": "Verantwortlichen ändern"
      },
      "attributes": {
        "introduction": "Einleitung",
        "responsible": "Verantwortlich",
        "title": "Titel"
      },
      "labels": {
        "ask_question": "Welche Art von Frage möchten Sie stellen?",
        "editInternalTitle": "Internen Titel bearbeiten?",
        "explainerNPSPart1": "Der Net Promoter Score ist ein Index von -100 bis 100, der misst, wie bereit Kunden sind, Ihre Organisation oder Ihre Projekte weiterzuempfehlen.",
        "explainerOpinionScale": "Messen Sie, wie sehr Ihre Kunden einer allgemeinen Aussage zustimmen.",
        "fixed_choice": "Multiple-Choice-Frage",
        "hidePreview": "Vorschau ausblenden",
        "moreInfo": "Weitere Informationen",
        "nps": "Net Promoter Score",
        "npsQuestion": "NPS",
        "open_ended": "Offene Frage",
        "opinion_scale": "Meinungsskala",
        "preview": "Vorschau",
        "satisfaction": "Zufriedenheit",
        "selectSurveyType": "Umfrage auswählen",
        "showPreview": "Vorschau anzeigen",
        "tab_summary": "Zusammenfassung",
        "tab_units": "Einheiten",
        "yes_no": "Ja-Nein"
      },
      "navigation": {
        "backToSurveyTypes": "Zurück zu den Umfragen"
      },
      "snackbars": {
        "duplicate": "Die Umfrage wurde erstellt. Der Kopiervorgang aus der Vorlage kann jedoch noch einige Minuten dauern."
      },
      "toasts": {
        "bulk_delete": "Umfrage erfolgreich gelöscht | Umfragen erfolgreich gelöscht",
        "update": "Umfrage erfolgreich aktualisiert"
      },
      "validation": {
        "nameAlreadyTaken": "Der Name wird für dieses Projekt bereits verwendet",
        "need_name": "Titel erforderlich",
        "selectSurveyType": "Wählen Sie mindestens 1 Umfrage aus"
      }
    }
  }
}
